export const planColumns = [
  { tag: "01", name: "BASIC", price: "$2,500 build", upkeep: "$10 / month upkeep", highlight: false },
  { tag: "02", name: "PRO", price: "$5,000 build", upkeep: "$20 / month upkeep", highlight: true },
  { tag: "03", name: "CUSTOM", price: "$10,000 build", upkeep: "$20 / month upkeep", highlight: false },
];

export const planRows = [
  { label: "Customizable homepage", values: [1, 1, 1] },
  { label: "Online selling", values: [1, 1, 1] },
  { label: "PayPal integration", values: [1, 1, 1] },
  { label: "Domain & SSL certificate", values: [1, 1, 1] },
  { label: "Color palette settings", values: [1, 1, 1] },
  { label: "Custom CSS properties", values: [1, 1, 1] },
  { label: "CSV reports", values: [0, 1, 1] },
  { label: "Dedicated hosting", values: [0, 1, 1] },
  { label: "Customizable pages", values: [0, 1, 1] },
  { label: "Custom licensing implementation", values: [0, 1, 1] },
  { label: "Media optimization & conversion", values: [0, 1, 1] },
  { label: "Journal", values: [0, 1, 1] },
  { label: "Custom frontend components*", values: [0, 1, 1] },
  { label: "Custom features", values: [0, 0, 1] },
  { label: "Complete frontend rebuild", values: [0, 0, 1] },
  { label: "Priority support", values: [0, 0, 1] },
];

export const planFootnote = "*Price not included";
